import ThemeOptions from './ThemeOptions';
import DashboardFrame from './Dashboards/DashboardFrame';
import Dashboards from './Dashboards/Dashboards';
import DashboardEdit from './Dashboards/DashboardEdit';
import CustomMenu from './CustomMenu';
import UserInfo from './UserInfo';
import TagInfo from './TagInfo';
import FloorInfo from './Common/FloorInfo';
import CategoryInfo from './Common/CategoryInfo';
import AppConfig from './Common/AppConfig';
import SocketInfo from './SocketInfo';
import ErrorHandler from './ErrorHandler';
import Notification from './Notification';
import BookMarkedItem from './Common/BookMarkedItem';
import FilterInfo from './FilterInfo';
import StatusInfo from './Common/StatusInfo';

export default {
    ThemeOptions,
    DashboardFrame,
    Dashboards,
    DashboardEdit,
    CustomMenu,
    UserInfo,
    TagInfo,
    FloorInfo,
    CategoryInfo,
    AppConfig,
    SocketInfo,
    ErrorHandler,
    Notification,
    BookMarkedItem,
    FilterInfo,
    StatusInfo,
};
